import axios, { AxiosResponse } from 'axios'
import { TMachineRequest } from '../../../coreGlobal/models/machines/machine'
import { ID, Response } from '../../../_metronic/helpers'
import { MachineFranchise, MachineFranchisesRequest, MachinesQueryResponse } from './_models'
import { AdminProductsResponse, ProductOption, toProductOptions } from '../../../components/ProductSelect'

const API_URL = process.env.REACT_APP_API_URL + '/api'
const MACHINE_URL = `${API_URL}/admin/machines`
const PRODUCT_URL = `${API_URL}/admin/products`

const createMachine = (data: TMachineRequest) => {
    return axios
      .post(MACHINE_URL, data)
      .then((response: any) => response.data)
      .then((response: any) => response.data)
}
const updateMachine = (machineId: string | number, data: TMachineRequest) =>{
  return axios
      .put(`${MACHINE_URL}/${machineId}`, data)
      .then((response: any) => response.data)
      .then((response: any) => response.data)
}
const getMachineById = (machineId: string | number) => {
  return axios
    .get(`${MACHINE_URL}/${machineId}?include=products`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getMachines = (query: string): Promise<MachinesQueryResponse> => {
  return axios
      .get(`${MACHINE_URL}?${query}`)
      .then((d: AxiosResponse<MachinesQueryResponse>) => d.data)
}

// Máquinas só se aplicam a Depilação a Laser (categoria 1). Usa o index do admin porque
// products/all depende da franquia selecionada na sessão.
const getProducts = (): Promise<ProductOption[]> => {
  return axios
    .get(`${PRODUCT_URL}?category=1&sort=name&order=asc&per_page=1000`)
    .then((response: AxiosResponse<AdminProductsResponse>) => toProductOptions(response.data))
}

const getMachineFranchises = (machineId: ID): Promise<MachineFranchise[]> => {
  return axios
    .get(`${MACHINE_URL}/${machineId}/franchises`)
    .then((response: AxiosResponse<Response<MachineFranchise[]>>) => response.data.data as MachineFranchise[])
}

const syncMachineFranchises = (machineId: ID, data: MachineFranchisesRequest) => {
  return axios
    .put(`${MACHINE_URL}/${machineId}/franchises`, data)
    .then((response: any) => response.data)
}

export {createMachine, updateMachine, getMachineById, getMachines, getProducts, getMachineFranchises, syncMachineFranchises};